import React, { useEffect, useState, useMemo } from "react";
import Axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import "./stripe.css";

function Stripe(props) {
  const [clientSecret, setClientSecret] = useState(null);
  const [stateNo, setStateNo] = useState(null);
  const [publishableKey, setPublishableKey] = useState(null);
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    const { match } = props;
    if (match && match.params && match.params.id) {
      (async () => {
        const sqlStateNo = match.params.id;
        const { data, status } = await Axios.post(`./api/stripe/${sqlStateNo}`);
        if (status === 200) {
          setClientSecret(data.clientSecret);
          setPublishableKey(data.publishableKey);
          setAmount(data.amount)
          setStateNo(sqlStateNo);
        }
      })();
    }
  }, []);

  const stripePromise = useMemo(async () => publishableKey && (await loadStripe(publishableKey)), [publishableKey]);

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };

  return clientSecret && stripePromise && stateNo ? (
    <div id="Stripe">
      <Elements options={options} stripe={stripePromise}>
        <CheckoutForm stateNo={stateNo} amount={amount} clientSecret={clientSecret} />
      </Elements>
    </div>
  ) : null;
}

export default Stripe;
